import "./../../styles/Reviews.css";

const ReviewHeader = () => {
    return (
        <div className="review-header">
            <div>
                <h1>Reviews & Ratings</h1>
                <p>
                    Manage customer reviews, ratings, moderation,
                    and provider feedback.
                </p>
            </div>
        </div>
    );
};

export default ReviewHeader;